module.exports = __webpack_public_path__ + "static/media/physly_logo_1200x628.4eddf5f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/physly_logo_1200x628.png
// module id = 601
// module chunks = 0